export default __webpack_public_path__ + "static/media/T850_CoC.7f9fdc69.pdf";